function toggleMobileMenu() {
  const menu = document.querySelector('.wp-block-modulr-mobile-menu');
  const navToggles = document.querySelectorAll('.wp-block-modulr-nav-toggle');
  if (!menu || navToggles.length === 0) return;

  const isActive = navToggles[0].classList.contains('active');

  navToggles.forEach(toggle => {
    if (isActive) {
      toggle.classList.remove('active');
    } else {
      toggle.classList.add('active');
    }
  });

  if (isActive) {
    menu.classList.remove('active');
  } else {
    menu.classList.add('active');
  }
}

function closeMenu() {
  const menu = document.querySelector('.wp-block-modulr-mobile-menu');
  const navToggles = document.querySelectorAll('.wp-block-modulr-nav-toggle');
  if (!menu || navToggles.length === 0) return;

  navToggles.forEach(toggle => {
    toggle.classList.remove('active');
  });

  menu.classList.remove('active');
}

document.addEventListener('DOMContentLoaded', () => {
  const navToggles = document.querySelectorAll('.wp-block-modulr-nav-toggle');
  if (navToggles.length === 0) return;
  navToggles.forEach(toggle => {
    toggle.addEventListener('click', toggleMobileMenu);
  });

  const menuItems = document.querySelectorAll('.wp-block-modulr-mobile-menu .menu-item, .wp-block-modulr-mobile-menu .menu-item a');
  menuItems.forEach(item => {
    item.addEventListener('click', (e) => {
      // Don't close mobile menu if clicking on a stacked vertical menu parent item
      // The stacked vertical menu handles its own submenu activation
      const stackedMenu = item.closest('.wp-block-modulr-vertical-menu[data-variation="stacked"]');
      if (stackedMenu) {
        const parentLi = item.closest('li.menu-item-has-children, li.page_item_has_children');
        // Only skip closing if this is a parent item (has children)
        // Leaf items should still close the menu
        if (parentLi) {
          return; // Let the stacked vertical menu handler deal with it
        }
      }
      closeMenu();
    });
  });
});

